import restClient from '../restClient';
export const SUBMITTED_PEP_RCA = 'SUBMITTED_PEP_RCA';
export const GET_PEP_ROLE_COUNTRIES = 'GET_PEP_ROLE_COUNTRIES';
export const GET_PEP_ROLES = 'GET_PEP_ROLES';
export const GET_RCA_ROLES = 'GET_RCA_ROLES';
export const FAILED_GET_PEP_ROLES = 'FAILED_GET_PEP_ROLES';
export const FAILED_GET_RCA_ROLES = 'FAILED_GET_RCA_ROLES';
export const FETCHING_PEP_ROLES = 'FETCHING_PEP_ROLES';
export const FETCHING_RCA_ROLES = 'FETCHING_RCA_ROLES';
export const PEP_RCA_SAVE_ERROR = 'PEP_RCA_SAVE_ERROR';
const doGetCountries = countries => ({
  countries,
  type: GET_PEP_ROLE_COUNTRIES
});
const doGetPepRoles = roles => ({
  roles,
  type: GET_PEP_ROLES
});
const failedToFetchPepRoles = error => ({
  error,
  type: FAILED_GET_PEP_ROLES
});
const doGetRcaRoles = roles => ({
  roles,
  type: GET_RCA_ROLES
});
const failedToFetchRcaRoles = error => ({
  error,
  type: FAILED_GET_RCA_ROLES
});
const fetchingPepRoles = () => ({
  type: FETCHING_PEP_ROLES
});
const fetchingRcaRoles = () => ({
  type: FETCHING_RCA_ROLES
});
export const getPepRoleCountries = () => async dispatch => {
  const countries = await restClient.pepRoleCountries();
  dispatch(doGetCountries(countries));
};
export const getPepRoles = () => async dispatch => {
  dispatch(fetchingPepRoles());
  try {
    const pepRoles = await restClient.getPepRoleTypes();
    dispatch(doGetPepRoles(pepRoles));
  } catch (error) {
    dispatch(failedToFetchPepRoles(error));
  }
};
export const getRcaRoles = () => async dispatch => {
  dispatch(fetchingRcaRoles());
  try {
    const rcaRoles = await restClient.getRcaRoleTypes();
    dispatch(doGetRcaRoles(rcaRoles));
  } catch (error) {
    dispatch(failedToFetchRcaRoles(error));
  }
};
const pepRcaSubmitted = () => ({
  type: SUBMITTED_PEP_RCA
});
export const doPostPepRca = section => async dispatch => {
  try {
    await restClient.addPepAndRca(section);
    dispatch(pepRcaSubmitted());
  } catch (e) {
    dispatch({
      type: PEP_RCA_SAVE_ERROR,
      error: e
    });
  }
};